import {bindActionCreators, Dispatch} from 'redux';
import {connect} from 'react-redux';

import {createSelector} from 'reselect';

import {Post} from 'mattermost-redux/types/posts';
import {GenericAction} from 'mattermost-redux/types/actions';

import {makeGetPostsForThread} from 'mattermost-redux/selectors/entities/posts';
import {getCurrentUser} from 'mattermost-redux/selectors/entities/users';

import type {GlobalState} from 'types/store';

import {updateThreadToastStatus} from 'features/threads/actions/update_thread_toast_status';

import NewRepliesBanner from './new_replies_banner';

type Props = {
    threadId: Post['id'];
    lastViewedBottom: number;
    canShow: boolean;
}

function makeGetHasNewRepliesSince(): (state: GlobalState, threadId: string, lastViewed: number) => boolean {
    const getPostsForThread = makeGetPostsForThread();

    return createSelector(
        getPostsForThread,
        getCurrentUser,
        (_state: GlobalState, _threadId: string, lastViewed: number) => lastViewed,
        (posts, currentUser, lastViewed) => posts.
            some((post) => post.create_at > lastViewed && post.user_id !== currentUser.id),
    );
}

function makeMapStateToProps() {
    const getHasNewRepliesSince = makeGetHasNewRepliesSince();

    return (state: GlobalState, ownProps: Props) => {
        const {threadId, lastViewedBottom, canShow} = ownProps;

        const hasNewReplies = canShow ? getHasNewRepliesSince(state, threadId, lastViewedBottom) : false;

        return {
            hasNewReplies,
        };
    };
}

function mapDispatchToProps(dispatch: Dispatch<GenericAction>) {
    return {
        actions: bindActionCreators({
            updateThreadToastStatus,
        }, dispatch),
    };
}

export default connect(makeMapStateToProps, mapDispatchToProps)(NewRepliesBanner);
